import type { DocumentTypePayload } from '@Application/Documents/DocumentTypes/Actions/documentTypesFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `isSystem` types are never renamed nor archived: the UI hides their write actions rather than
 * relying only on the server's `422`.
 */
class DocumentTypeView {
	readonly id: number;
	readonly key: string;
	readonly label: string;
	readonly isSystem: boolean;
	readonly archivedAt: string | null;

	constructor(payload: DocumentTypePayload) {
		this.id = payload.id;
		this.key = payload.key;
		this.label = payload.label;
		this.isSystem = payload.isSystem;
		this.archivedAt = payload.archivedAt;

		Object.freeze(this);
	}

	get isArchived(): boolean {
		return this.archivedAt !== null;
	}

	/** Not a decorated class (no `@ValidatedClass`): a plain `new` is the correct clone here. */
	withArchivedAt(archivedAt: string | null): DocumentTypeView {
		return new DocumentTypeView({
			id: this.id,
			key: this.key,
			label: this.label,
			isSystem: this.isSystem,
			archivedAt,
		});
	}
}

export default DocumentTypeView;
